export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])(?!.*\s).{10,}$/;

export const STRICT_PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\\^$*.\\[\]{}()?\-!@#%&/\\,<>';:|_=+~`"])[A-Za-z\d^$*.\\[\]{}()?\-!@#%&/\\,<>';:|_=+~`"]{10,}$/;
